export class KVRooftopAnnotation {
  cutsAndTears: boolean
  punctures: boolean
  abrasionsAndScuffing: boolean
  cracks: boolean
  delamination: boolean
  alligatoring: boolean
  blistersAndBubbles: boolean
  wetInsulation: boolean
  moistureIntrusionWaterPonding: boolean
  capillaryMoistureIntrusion: boolean
  condensationDamage: boolean
  efflorescence: boolean
  depressionsLowSpots: boolean
  saggingDeckSubstrate: boolean
  openOrUnstableJoints: boolean
  delaminatedLayersCoreSeparation: boolean
  deformationOfRoofSurface: boolean
  warpedOrBowedPanels: boolean
  backedOutFasteners: boolean
  missingFasteners: boolean
  corrodedOrRustedFasteners: boolean
  improperlySealedFasteners: boolean
  looseOrDetachedFlashing: boolean
  crackedSealantAtFlashing: boolean
  improperCounterflashingStepFlashingInstallation: boolean
  seamFailuresSplitSeams: boolean
  membraneShrinkage: boolean
  fishmouths: boolean
  tentings: boolean
  openTerminationsEdges: boolean
  thermalBridgingInsulationExposure: boolean
  uvDamageBrittleness: boolean
  surfaceChalkiness: boolean
  colorFadingDiscoloration: boolean
  surfaceErosion: boolean
  windUpliftWindScour: boolean
  hailDamageImpactCraters: boolean
  treeLimbOrDebrisDamage: boolean
  cloggedRoofDrainsScuppersGutters: boolean
  blockedOverflowOutlets: boolean
  improperDrainageSlope: boolean
  overflowOrBackupEvidence: boolean
  defectivePipeBootsFlashingCollars: boolean
  leakySkylightPerimeters: boolean
  improperHvacUnitMounting: boolean
  corrodedMechanicalSupportsOrRails: boolean
  debrisAccumulationAroundPenetrations: boolean
  looseGravelStopsEdgeFlashing: boolean
  parapetWallDeterioration: boolean
  waterIntrusionAtCopingsCaps: boolean
  gapsAtExpansionJoints: boolean
  mossOrAlgaeGrowth: boolean
  lichenMoldStains: boolean
  rootPenetration: boolean
  birdOrPestNestingDamage: boolean

  constructor() {
    this.cutsAndTears = false
    this.punctures = false
    this.abrasionsAndScuffing = false
    this.cracks = false
    this.delamination = false
    this.alligatoring = false
    this.blistersAndBubbles = false
    this.wetInsulation = false
    this.moistureIntrusionWaterPonding = false
    this.capillaryMoistureIntrusion = false
    this.condensationDamage = false
    this.efflorescence = false
    this.depressionsLowSpots = false
    this.saggingDeckSubstrate = false
    this.openOrUnstableJoints = false
    this.delaminatedLayersCoreSeparation = false
    this.deformationOfRoofSurface = false
    this.warpedOrBowedPanels = false
    this.backedOutFasteners = false
    this.missingFasteners = false
    this.corrodedOrRustedFasteners = false
    this.improperlySealedFasteners = false
    this.looseOrDetachedFlashing = false
    this.crackedSealantAtFlashing = false
    this.improperCounterflashingStepFlashingInstallation = false
    this.seamFailuresSplitSeams = false
    this.membraneShrinkage = false
    this.fishmouths = false
    this.tentings = false
    this.openTerminationsEdges = false
    this.thermalBridgingInsulationExposure = false
    this.uvDamageBrittleness = false
    this.surfaceChalkiness = false
    this.colorFadingDiscoloration = false
    this.surfaceErosion = false
    this.windUpliftWindScour = false
    this.hailDamageImpactCraters = false
    this.treeLimbOrDebrisDamage = false
    this.cloggedRoofDrainsScuppersGutters = false
    this.blockedOverflowOutlets = false
    this.improperDrainageSlope = false
    this.overflowOrBackupEvidence = false
    this.defectivePipeBootsFlashingCollars = false
    this.leakySkylightPerimeters = false
    this.improperHvacUnitMounting = false
    this.corrodedMechanicalSupportsOrRails = false
    this.debrisAccumulationAroundPenetrations = false
    this.looseGravelStopsEdgeFlashing = false
    this.parapetWallDeterioration = false
    this.waterIntrusionAtCopingsCaps = false
    this.gapsAtExpansionJoints = false
    this.mossOrAlgaeGrowth = false
    this.lichenMoldStains = false
    this.rootPenetration = false
    this.birdOrPestNestingDamage = false
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  static fromJSON(json: any): KVRooftopAnnotation {
    const annotation = new KVRooftopAnnotation()

    // Set all boolean properties from JSON
    if (json.cutsAndTears !== undefined)
      annotation.cutsAndTears = json.cutsAndTears
    if (json.punctures !== undefined) annotation.punctures = json.punctures
    if (json.abrasionsAndScuffing !== undefined)
      annotation.abrasionsAndScuffing = json.abrasionsAndScuffing
    if (json.cracks !== undefined) annotation.cracks = json.cracks
    if (json.delamination !== undefined)
      annotation.delamination = json.delamination
    if (json.alligatoring !== undefined)
      annotation.alligatoring = json.alligatoring
    if (json.blistersAndBubbles !== undefined)
      annotation.blistersAndBubbles = json.blistersAndBubbles
    if (json.wetInsulation !== undefined)
      annotation.wetInsulation = json.wetInsulation
    if (json.moistureIntrusionWaterPonding !== undefined)
      annotation.moistureIntrusionWaterPonding =
        json.moistureIntrusionWaterPonding
    if (json.capillaryMoistureIntrusion !== undefined)
      annotation.capillaryMoistureIntrusion = json.capillaryMoistureIntrusion
    if (json.condensationDamage !== undefined)
      annotation.condensationDamage = json.condensationDamage
    if (json.efflorescence !== undefined)
      annotation.efflorescence = json.efflorescence
    if (json.depressionsLowSpots !== undefined)
      annotation.depressionsLowSpots = json.depressionsLowSpots
    if (json.saggingDeckSubstrate !== undefined)
      annotation.saggingDeckSubstrate = json.saggingDeckSubstrate
    if (json.openOrUnstableJoints !== undefined)
      annotation.openOrUnstableJoints = json.openOrUnstableJoints
    if (json.delaminatedLayersCoreSeparation !== undefined)
      annotation.delaminatedLayersCoreSeparation =
        json.delaminatedLayersCoreSeparation
    if (json.deformationOfRoofSurface !== undefined)
      annotation.deformationOfRoofSurface = json.deformationOfRoofSurface
    if (json.warpedOrBowedPanels !== undefined)
      annotation.warpedOrBowedPanels = json.warpedOrBowedPanels
    if (json.backedOutFasteners !== undefined)
      annotation.backedOutFasteners = json.backedOutFasteners
    if (json.missingFasteners !== undefined)
      annotation.missingFasteners = json.missingFasteners
    if (json.corrodedOrRustedFasteners !== undefined)
      annotation.corrodedOrRustedFasteners = json.corrodedOrRustedFasteners
    if (json.improperlySealedFasteners !== undefined)
      annotation.improperlySealedFasteners = json.improperlySealedFasteners
    if (json.looseOrDetachedFlashing !== undefined)
      annotation.looseOrDetachedFlashing = json.looseOrDetachedFlashing
    if (json.crackedSealantAtFlashing !== undefined)
      annotation.crackedSealantAtFlashing = json.crackedSealantAtFlashing
    if (json.improperCounterflashingStepFlashingInstallation !== undefined)
      annotation.improperCounterflashingStepFlashingInstallation =
        json.improperCounterflashingStepFlashingInstallation
    if (json.seamFailuresSplitSeams !== undefined)
      annotation.seamFailuresSplitSeams = json.seamFailuresSplitSeams
    if (json.membraneShrinkage !== undefined)
      annotation.membraneShrinkage = json.membraneShrinkage
    if (json.fishmouths !== undefined) annotation.fishmouths = json.fishmouths
    if (json.tentings !== undefined) annotation.tentings = json.tentings
    if (json.openTerminationsEdges !== undefined)
      annotation.openTerminationsEdges = json.openTerminationsEdges
    if (json.thermalBridgingInsulationExposure !== undefined)
      annotation.thermalBridgingInsulationExposure =
        json.thermalBridgingInsulationExposure
    if (json.uvDamageBrittleness !== undefined)
      annotation.uvDamageBrittleness = json.uvDamageBrittleness
    if (json.surfaceChalkiness !== undefined)
      annotation.surfaceChalkiness = json.surfaceChalkiness
    if (json.colorFadingDiscoloration !== undefined)
      annotation.colorFadingDiscoloration = json.colorFadingDiscoloration
    if (json.surfaceErosion !== undefined)
      annotation.surfaceErosion = json.surfaceErosion
    if (json.windUpliftWindScour !== undefined)
      annotation.windUpliftWindScour = json.windUpliftWindScour
    if (json.hailDamageImpactCraters !== undefined)
      annotation.hailDamageImpactCraters = json.hailDamageImpactCraters
    if (json.treeLimbOrDebrisDamage !== undefined)
      annotation.treeLimbOrDebrisDamage = json.treeLimbOrDebrisDamage
    if (json.cloggedRoofDrainsScuppersGutters !== undefined)
      annotation.cloggedRoofDrainsScuppersGutters =
        json.cloggedRoofDrainsScuppersGutters
    if (json.blockedOverflowOutlets !== undefined)
      annotation.blockedOverflowOutlets = json.blockedOverflowOutlets
    if (json.improperDrainageSlope !== undefined)
      annotation.improperDrainageSlope = json.improperDrainageSlope
    if (json.overflowOrBackupEvidence !== undefined)
      annotation.overflowOrBackupEvidence = json.overflowOrBackupEvidence
    if (json.defectivePipeBootsFlashingCollars !== undefined)
      annotation.defectivePipeBootsFlashingCollars =
        json.defectivePipeBootsFlashingCollars
    if (json.leakySkylightPerimeters !== undefined)
      annotation.leakySkylightPerimeters = json.leakySkylightPerimeters
    if (json.improperHvacUnitMounting !== undefined)
      annotation.improperHvacUnitMounting = json.improperHvacUnitMounting
    if (json.corrodedMechanicalSupportsOrRails !== undefined)
      annotation.corrodedMechanicalSupportsOrRails =
        json.corrodedMechanicalSupportsOrRails
    if (json.debrisAccumulationAroundPenetrations !== undefined)
      annotation.debrisAccumulationAroundPenetrations =
        json.debrisAccumulationAroundPenetrations
    if (json.looseGravelStopsEdgeFlashing !== undefined)
      annotation.looseGravelStopsEdgeFlashing =
        json.looseGravelStopsEdgeFlashing
    if (json.parapetWallDeterioration !== undefined)
      annotation.parapetWallDeterioration = json.parapetWallDeterioration
    if (json.waterIntrusionAtCopingsCaps !== undefined)
      annotation.waterIntrusionAtCopingsCaps = json.waterIntrusionAtCopingsCaps
    if (json.gapsAtExpansionJoints !== undefined)
      annotation.gapsAtExpansionJoints = json.gapsAtExpansionJoints
    if (json.mossOrAlgaeGrowth !== undefined)
      annotation.mossOrAlgaeGrowth = json.mossOrAlgaeGrowth
    if (json.lichenMoldStains !== undefined)
      annotation.lichenMoldStains = json.lichenMoldStains
    if (json.rootPenetration !== undefined)
      annotation.rootPenetration = json.rootPenetration
    if (json.birdOrPestNestingDamage !== undefined)
      annotation.birdOrPestNestingDamage = json.birdOrPestNestingDamage

    return annotation
  }

  static toJSON(annotation: KVRooftopAnnotation): Record<string, boolean> {
    return {
      cutsAndTears: annotation.cutsAndTears,
      punctures: annotation.punctures,
      abrasionsAndScuffing: annotation.abrasionsAndScuffing,
      cracks: annotation.cracks,
      delamination: annotation.delamination,
      alligatoring: annotation.alligatoring,
      blistersAndBubbles: annotation.blistersAndBubbles,
      wetInsulation: annotation.wetInsulation,
      moistureIntrusionWaterPonding: annotation.moistureIntrusionWaterPonding,
      capillaryMoistureIntrusion: annotation.capillaryMoistureIntrusion,
      condensationDamage: annotation.condensationDamage,
      efflorescence: annotation.efflorescence,
      depressionsLowSpots: annotation.depressionsLowSpots,
      saggingDeckSubstrate: annotation.saggingDeckSubstrate,
      openOrUnstableJoints: annotation.openOrUnstableJoints,
      delaminatedLayersCoreSeparation:
        annotation.delaminatedLayersCoreSeparation,
      deformationOfRoofSurface: annotation.deformationOfRoofSurface,
      warpedOrBowedPanels: annotation.warpedOrBowedPanels,
      backedOutFasteners: annotation.backedOutFasteners,
      missingFasteners: annotation.missingFasteners,
      corrodedOrRustedFasteners: annotation.corrodedOrRustedFasteners,
      improperlySealedFasteners: annotation.improperlySealedFasteners,
      looseOrDetachedFlashing: annotation.looseOrDetachedFlashing,
      crackedSealantAtFlashing: annotation.crackedSealantAtFlashing,
      improperCounterflashingStepFlashingInstallation:
        annotation.improperCounterflashingStepFlashingInstallation,
      seamFailuresSplitSeams: annotation.seamFailuresSplitSeams,
      membraneShrinkage: annotation.membraneShrinkage,
      fishmouths: annotation.fishmouths,
      tentings: annotation.tentings,
      openTerminationsEdges: annotation.openTerminationsEdges,
      thermalBridgingInsulationExposure:
        annotation.thermalBridgingInsulationExposure,
      uvDamageBrittleness: annotation.uvDamageBrittleness,
      surfaceChalkiness: annotation.surfaceChalkiness,
      colorFadingDiscoloration: annotation.colorFadingDiscoloration,
      surfaceErosion: annotation.surfaceErosion,
      windUpliftWindScour: annotation.windUpliftWindScour,
      hailDamageImpactCraters: annotation.hailDamageImpactCraters,
      treeLimbOrDebrisDamage: annotation.treeLimbOrDebrisDamage,
      cloggedRoofDrainsScuppersGutters:
        annotation.cloggedRoofDrainsScuppersGutters,
      blockedOverflowOutlets: annotation.blockedOverflowOutlets,
      improperDrainageSlope: annotation.improperDrainageSlope,
      overflowOrBackupEvidence: annotation.overflowOrBackupEvidence,
      defectivePipeBootsFlashingCollars:
        annotation.defectivePipeBootsFlashingCollars,
      leakySkylightPerimeters: annotation.leakySkylightPerimeters,
      improperHvacUnitMounting: annotation.improperHvacUnitMounting,
      corrodedMechanicalSupportsOrRails:
        annotation.corrodedMechanicalSupportsOrRails,
      debrisAccumulationAroundPenetrations:
        annotation.debrisAccumulationAroundPenetrations,
      looseGravelStopsEdgeFlashing: annotation.looseGravelStopsEdgeFlashing,
      parapetWallDeterioration: annotation.parapetWallDeterioration,
      waterIntrusionAtCopingsCaps: annotation.waterIntrusionAtCopingsCaps,
      gapsAtExpansionJoints: annotation.gapsAtExpansionJoints,
      mossOrAlgaeGrowth: annotation.mossOrAlgaeGrowth,
      lichenMoldStains: annotation.lichenMoldStains,
      rootPenetration: annotation.rootPenetration,
      birdOrPestNestingDamage: annotation.birdOrPestNestingDamage,
    }
  }
}
